import React from 'react';
import AddInsurancePlan from '../components/AddInsurancePlan';

const InsurancePlanFormPage: React.FC = () => <AddInsurancePlan />;

export default InsurancePlanFormPage;
